import cn from 'classnames';
import { ReactNode } from 'react';
import * as RadixToast from '@radix-ui/react-toast';

import { Icon } from '../Icon';

import styles from './Toast.module.scss';

export type ToastProps = Omit<
  RadixToast.ToastProps,
  'open' | 'onOpenChange'
> & {
  text: ReactNode | string;
  onOpenChange?(open: boolean): void;
  title?: ReactNode | string;
  action?: ReactNode;
  withoutCloseButton?: boolean;
  duration?: number;
  className?: string;
  // TODO: add this to toast
  iconType?: 'info' | 'success' | 'warning' | 'error';
  link?: string;
  linkText?: string;
};

export function Toast({
  text,
  onOpenChange,
  title,
  action,
  withoutCloseButton = false,
  duration = 5000,
  iconType = 'info',
  link,
  linkText,
  className,
}: ToastProps): JSX.Element {
  return (
    <RadixToast.Root
      defaultOpen
      duration={duration}
      className={cn(className, styles.root, styles[iconType])}
      onOpenChange={onOpenChange}
    >
      {title !== undefined && <RadixToast.Title>{title}</RadixToast.Title>}
      {iconType !== undefined && (
        <Icon icon={iconType} className={styles.statusIcon} />
      )}
      <RadixToast.Description>
        {text}
        {link !== undefined && linkText !== undefined && (
          <p>
            <a href={link} target="_blank" rel="noreferrer">
              {linkText}
            </a>
          </p>
        )}
      </RadixToast.Description>

      {action !== undefined && (
        <RadixToast.Action altText="">{action}</RadixToast.Action>
      )}

      {!withoutCloseButton && (
        <RadixToast.Close className={styles.closeButton} aria-label="Close">
          <Icon icon="close" />
        </RadixToast.Close>
      )}
    </RadixToast.Root>
  );
}
